import { render, staticRenderFns } from "./WGModal.vue?vue&type=template&id=31db6146&scoped=true"
import script from "./WGModal.vue?vue&type=script&lang=js"
export * from "./WGModal.vue?vue&type=script&lang=js"
import style0 from "./WGModal.vue?vue&type=style&index=0&id=31db6146&prod&lang=scss&scoped=true"
import style1 from "./WGModal.vue?vue&type=style&index=1&id=31db6146&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../calendar/spa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31db6146",
  null
  
)

export default component.exports